module.exports = __webpack_public_path__ + "img/flower.8c86f621.svg";